import { FC, useEffect } from 'react';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { RootState } from 'store';
import { useAppSelector } from 'hooks/useStore';
import { selectWaiting } from 'store/pages/pagesSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
import { selectEventById } from 'store/quizEvents/quizEventsSelectors';
import QuizTypes from 'types/QuizTypes';
import QuizEventStatuses from 'types/QuizEventStatuses';
// Components
import AppBar from 'components/AppBar';

const WaitingPage:FC = () => {
  const navigateTo = useNavigateTo();

  const quiz = useAppSelector(selectQuiz);
  const waiting = useAppSelector(selectWaiting);
  const event = useAppSelector((state:RootState) => selectEventById(state, { eventId: waiting?.event }))
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  useEffect(() => {
    if (previewPageMode) return;

    if (!waiting || (event && event.status === QuizEventStatuses.Triggered)) navigateTo('pages-handler');
    // eslint-disable-next-line
  }, [event]);

  const scoreVisible = [QuizTypes.BeatTheExpert, QuizTypes.Scoring, QuizTypes.Streak].includes(quiz.type);

  if (!waiting) return null;
  return (
    <div
      className="h-full flex flex-col p-4"
      style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
    >
      <AppBar scoreVisible={scoreVisible} />
      <div className="grow flex flex-col justify-center items-center gap-6 py-4">
        {waiting.image ? (
          <img
            className="relative z-10 shadow-primary rounded-lg"
            src={waiting.image}
            alt=""
          />
        ) : null}
        {waiting.text ? (
          <p className="text-md font-semibold text-primary text-center whitespace-pre-line">{waiting.text}</p>
        ) : null}
      </div>
    </div>
  )
}

export default WaitingPage;
